import { useMemo } from 'react';
import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';
import { BalloonProps } from '@/types';

const floatBob = keyframes`
  0%, 100% { transform: translateY(0px); }
  50%       { transform: translateY(-18px); }
`;

const PositionLayer = styled(motion.div)`
  position: absolute;
  width: 120px;
  cursor: none;
`;

const BalloonBody = styled(motion.div)<{
  $color: string;
  $duration: number;
  $delay: number;
}>`
  position: relative;
  width: 120px;
  height: 140px;
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: white;
  text-align: center;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  background-color: ${p => p.$color};
  user-select: none;
  animation: ${floatBob} ${p => p.$duration}s ease-in-out ${p => p.$delay}s infinite;

  &::after {
    content: '';
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 30px;
    background: rgba(255, 255, 255, 0.6);
  }
`;

export const Balloon = ({ concept, x, y, color, onPop }: BalloonProps) => {
  const duration = useMemo(() => 2 + Math.random() * 2, []);
  const delay = useMemo(() => Math.random() * 2, []);

  return (
    <PositionLayer
      initial={{ left: x, top: y, scale: 0 }}
      animate={{ left: x, top: y, scale: 1 }}
      exit={{
        scale: [1, 1.3, 0],
        opacity: [1, 0.5, 0],
        transition: { duration: 0.3 },
      }}
      transition={{
        scale: { duration: 0.3 },
        left: { type: 'spring', stiffness: 45, damping: 16 },
        top: { type: 'spring', stiffness: 45, damping: 16 },
      }}
      onClick={() => onPop(concept)}
    >
      <BalloonBody
        $color={color}
        $duration={duration}
        $delay={delay}
        whileHover={{ scale: 1.1 }}
      >
        {concept.name}
      </BalloonBody>
    </PositionLayer>
  );
};
